import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalIndicador(props) {
  const indicador = props.model;
  const periodo = moment(indicador.valueSearch?.Periodo).format('YYYY-MM');

  const [divisions, setDivisions] = useState([]);
  const [marca, setMarca] = useState(indicador.sale_arcor_division_id);

  async function listDivisions() {
    let response = await wsGetAll('sale/arcor_divisions');
    if (response.success) setDivisions(response.data);
  }

  useEffect(() => {
    listDivisions();
    setMarca(indicador.sale_arcor_division_id);
  }, [indicador.open]);

  return (
    <>
      <Modal
        title={`Indicador de Arcor`}
        model={indicador}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/arcor-indicators'
        dataForce={{
          sale_arcor_division_id: marca,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            defaultValue={!!indicador ? indicador.type : ''}
            inputProps={{
              name: 'type',
            }}
          >
            <MenuItem value="I">Compra</MenuItem>
            <MenuItem value="O">Venta</MenuItem>
            <MenuItem value="C">Cobertura</MenuItem>
          </Select>
        </FormControl>
        <Autocomplete
          disableClearable
          options={divisions}
          getOptionLabel={(item) => item.description}
          renderInput={(params) => (
            <TextField {...params} label="División" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { setMarca(item?.id); }}
          value={divisions.find((d) => String(d.id) === String(marca)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!indicador ? indicador.description : ''}
          required
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!indicador ? indicador.quota : ''}
        />
      </Modal>
    </>
  );
});
